<template>
  <v-timeline align="center">
    <v-timeline-item side="start" dot-color="secondary">
      <template v-slot:opposite>
        <v-img src="/assets/custom/img/logos/original_case_logo.jpg" alt="Original CASE logo" width="150" />
      </template>
      <div class="text-end">
        <div>Feb 2012</div>
        <div class="text-secondary h5 font-emphasis">Founding of Case Consulting</div>
        <p class="text-tertiary">
          Case Consulting was founded by Paul Farmer to deliver high-quality technology services supporting national
          security missions. The company specialized in software development, engineering, and cloud solutions, designed
          to meet the unique needs of government clients.
        </p>
      </div>
    </v-timeline-item>
    <v-timeline-item side="end" dot-color="secondary">
      <template v-slot:opposite>
        <v-img src="/assets/custom/img/logos/fireteam_logo.png" alt="FireTeam Solutions logo" width="150" />
      </template>
      <div>
        <div>Oct 2022</div>
        <div class="text-secondary h5 font-emphasis">Merger with FireTeam Solutions</div>
        <p class="text-tertiary">
          In October 2022, Case Consulting merged with FireTeam Solutions, a secure engineering and cloud-focused
          company founded by Nick Harscher and backed by AE Industrial Partners. This merger combined Case Consulting's
          technical strengths with FireTeam's expertise in the OSINT mission area, creating a more comprehensive
          provider for defense and intelligence sectors.
        </p>
      </div>
    </v-timeline-item>
    <v-timeline-item side="start" dot-color="secondary">
      <template v-slot:opposite>
        <v-img src="/assets/custom/img/case/nav_logo.png" alt="CASE logo" width="150" />
      </template>
      <div class="text-end">
        <div>Early 2023</div>
        <div class="text-secondary h5 font-emphasis">Rebranded to CASE</div>
        <p class="text-tertiary">
          Following the merger, the combined entity rebranded to CASE, unifying all employees and capabilities under one
          identity.
        </p>
      </div>
    </v-timeline-item>
    <v-timeline-item side="end" dot-color="secondary">
      <template v-slot:opposite>
        <v-img src="/assets/custom/img/logos/cyk_logo.png" alt="CyberKinetics logo" width="150" />
      </template>
      <div>
        <div>Apr 2024</div>
        <div class="text-secondary h5 font-emphasis">Merger with CyberKinetics</div>
        <p class="text-tertiary">
          Founded by Brandon Lally in 2015, CyberKinetics brought additional expertise in cybersecurity, cloud
          engineering, and data analytics. This integration aligns with CASE's strategy to expand its portfolio, adding
          unique capabilities that enhance CASE's position in key markets.
        </p>
      </div>
    </v-timeline-item>
    <v-timeline-item side="start" dot-color="secondary">
      <template v-slot:opposite>
        <v-img src="/assets/custom/img/logos/rag_logo.png" alt="CyberKinetics logo" width="150" />
      </template>
      <div class="text-end">
        <div>July 2025</div>
        <div class="text-secondary h5 font-emphasis">Merger with Ragnarok</div>
        <p class="text-tertiary">
          Founded in 2015 by Ethan Grambow, Thomas Dougherty, and Chris Santiago, Ragnarok joined the CASE team in July
          2025, bringing with it a passion for delivering innovative, tailored solutions. This union reinforces a shared
          ‘Mission First’ mindset dedicated to addressing the challenges facing their federal and commercial clients.
        </p>
      </div>
    </v-timeline-item>
  </v-timeline>
</template>
